var render = function () {
  var _vm$configuration$mod, _vm$configuration$mod2, _vm$configuration$mod3, _vm$configuration$mod4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('focus-trap', {
    attrs: {
      "active": _vm.focusTrapActive
    }
  }, [_c('section', {
    class: ['customizer', _vm.themeBackground, {
      'is-apac': _vm.regionIsApac
    }],
    style: _vm.themeBackgroundStyle
  }, [_c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.utils.trayDisabled.geostates && !_vm.$store.state.utils.isDesignTransfering,
      expression: "$store.state.utils.trayDisabled.geostates && !$store.state.utils.isDesignTransfering"
    }],
    attrs: {
      "classes": "customizer-base-spinner"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNewLoadingSpinner,
      expression: "showNewLoadingSpinner"
    }],
    staticClass: "customizer-design-modal__spinner-wrapper"
  }, [_c('loading-spinner', {
    ref: "spinner",
    attrs: {
      "show-spinner-default": true
    }
  })], 1), _vm.configuration ? [_vm.themeVideo ? _c('div', {
    class: _vm.themeVideo
  }, [_c('video', {
    attrs: {
      "id": "themeVideo",
      "muted": "",
      "autoplay": "",
      "loop": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "id": "webm_src",
      "src": "".concat(_vm.themeVideoSrc, ".webm"),
      "type": "video/webm"
    }
  }), _c('source', {
    attrs: {
      "id": "mp4_src",
      "src": "".concat(_vm.themeVideoSrc, ".mp4"),
      "type": "video/mp4"
    }
  }), _vm._v("\n          Your browser does not support HTML5 video.\n        ")])]) : _vm._e(), _vm.configuration.enableCustomizerNewHeader && !_vm.queryParams.slim ? _c('customizer-new-header', {
    attrs: {
      "enable-randomize": _vm.isRandomizeEnabled && _vm.isMobile,
      "enable-undo": _vm.configuration.enableUndo,
      "enable-start-over": _vm.configuration.enableStartOver,
      "enable-share": _vm.enableShareButton,
      "enable-favorites": _vm.configuration.enableFavorites && !_vm.disableFavorites,
      "enable-transfer-design": _vm.enableTransferDesignButton,
      "enable-splash-page": _vm.enableSplashPage && (_vm.isMobile || _vm.screenOrientation === 'landscape'),
      "enable-buy-panel": _vm.configuration.enableBuyPanel,
      "enable-finish-my-design": _vm.enableFinishMyDesign
    }
  }) : _vm._e(), _c('scene-setup'), (_vm.isApparelEnabled || _vm.isFlyOutMenuEnable) && !_vm.queryParams.slim ? _c('standard-navigation-wrapper') : _vm._e(), _vm.configuration.enableAtomicSwatchTray && !_vm.queryParams.slim ? _c('swatch-tray', {
    scopedSlots: _vm._u([_vm.renderSwatchView ? {
      key: "navigation",
      fn: function fn() {
        return [!_vm.isFlyOutMenuEnable && !_vm.isApparelEnabled ? _c('legacy-navigation') : _vm._e()];
      },
      proxy: true
    } : null, {
      key: "buybutton",
      fn: function fn() {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.configuration.enableBuyPanel && _vm.isMobile,
            expression: "configuration.enableBuyPanel && isMobile"
          }],
          class: ["customizer-new-header__container-buy-button customizer-new-header__container-buy-button--mobile zoom-level-".concat(_vm.zoomLevel), {
            'customizer-new-header__container-buy-button__apparel-mobile': _vm.isApparelEnabled || _vm.configuration.enableFlyOutMenu
          }]
        }, [_c('buy-button-label', {
          staticClass: "customizer-new-header__buy-button"
        })], 1)];
      },
      proxy: true
    }], null, true)
  }) : _vm._e(), !_vm.configuration.enableAtomicSwatchTray && !_vm.queryParams.slim ? _c('swatches-view', {
    scopedSlots: _vm._u([_vm.renderSwatchView ? {
      key: "navigation",
      fn: function fn() {
        return [!_vm.isFlyOutMenuEnable && !_vm.isApparelEnabled ? _c('legacy-navigation') : _vm._e()];
      },
      proxy: true
    } : null, {
      key: "buybutton",
      fn: function fn() {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.configuration.enableBuyPanel && _vm.isMobile,
            expression: "configuration.enableBuyPanel && isMobile"
          }],
          class: ["customizer-new-header__container-buy-button customizer-new-header__container-buy-button--mobile zoom-level-".concat(_vm.zoomLevel), {
            'customizer-new-header__container-buy-button__apparel-mobile': _vm.isApparelEnabled || _vm.configuration.enableFlyOutMenu
          }]
        }, [_c('buy-button-label', {
          staticClass: "customizer-new-header__buy-button"
        })], 1)];
      },
      proxy: true
    }], null, true)
  }) : _vm._e(), _vm.isPersonalizationEnabled && _vm.configuration.enableEmbroidery && !_vm.configuration.modals.embroidery || !_vm.queryParams.slim ? _c('embroidery') : _vm._e(), _vm.isPersonalizationEnabled && _vm.configuration.modals.embroidery && !_vm.queryParams.slim ? _c('embroidery-modal') : _vm._e(), _vm._t("default"), _vm.configuration.vct_settings && _vm.configuration.vct_settings.pattern_maker.enabled && !_vm.configuration.modals.patternMaker || !_vm.queryParams.slim ? _c('patternmaker-modal', {
    attrs: {
      "is-main-app": false
    }
  }) : _vm._e(), _vm.configuration.vct_settings && _vm.configuration.vct_settings.pattern_maker.enabled && _vm.configuration.modals.patternMaker || !_vm.queryParams.slim ? _c('pattern-maker') : _vm._e(), _vm.configuration.vct_settings && _vm.configuration.vct_settings.custom_checkerboard.enabled && !_vm.queryParams.slim ? [_c('customcheckerboard', {
    attrs: {
      "is-main-app": false
    }
  })] : _vm._e(), (_vm.isUGCEnabled || _vm.isImageLibraryEnabled) && !_vm.queryParams.slim ? [_vm.configuration.enableIntroVideo ? [_vm.configuration.modals.ugcIntroVideos ? _c('intro-videos-modal') : _c('intro-videos-wrapper')] : _vm._e(), (_vm$configuration$mod = _vm.configuration.modals) !== null && _vm$configuration$mod !== void 0 && _vm$configuration$mod.ugcRepositionWarning ? _c('ugc-reposition-warning-modal') : _c('new-reposition-warning-modal'), (_vm$configuration$mod2 = _vm.configuration.modals) !== null && _vm$configuration$mod2 !== void 0 && _vm$configuration$mod2.ugcSizeSelection ? _c('ugc-size-selection-modal') : _c('new-size-selection-modal'), _vm.configuration.enableNewUgcModal ? _c('new-ugc-modal') : _c('ugc-modal'), !_vm.configuration.ugc.enableNewUgcTermConditions ? _c('terms-condition-modal') : _c('new-terms-condition-modal'), (_vm$configuration$mod3 = _vm.configuration.modals) !== null && _vm$configuration$mod3 !== void 0 && _vm$configuration$mod3.ugcPlacementError ? _c('ugc-placement-warning-modal') : _c('new-placement-warning-modal'), (_vm$configuration$mod4 = _vm.configuration.modals) !== null && _vm$configuration$mod4 !== void 0 && _vm$configuration$mod4.ugcUploading ? _c('ugc-uploading-image') : _c('new-upload-modal'), _vm.configuration.modals.ugcErrorImg ? _c('ugc-upload-image-error-modal') : _c('new-upload-error-modal')] : _vm._e(), !_vm.queryParams.slim && _vm.isImageLibraryEnabled ? _c('AddYourImageGallery') : _vm._e(), !_vm.queryParams.slim ? _c('new-modal-wrapper', {
    ref: "recipeValidationModal",
    attrs: {
      "widthModal": '92%',
      "heightModal": '55%',
      "modal-name": "recipeValidationModal",
      "cta-primary-button": "startOverAccept",
      "cta-secondary-button": "reset",
      "show-close-icon": false,
      "click-to-close": false
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$refs.recipeValidation.startOver();
      },
      "cta-secondary-action": function ctaSecondaryAction($event) {
        return _vm.$refs.recipeValidation.resetComponent();
      }
    }
  }, [_c('recipe-validation-modal', {
    ref: "recipeValidation"
  })], 1) : _vm._e(), _vm.configuration.enableNewRecipeDeclinedModal && !_vm.queryParams.slim ? _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '80%',
      "maxWidthModal": 500,
      "modal-name": "recipeDeclinedModal",
      "cta-primary-button": "recipeDeclinedContCustomizing"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$modal.hide('recipeDeclinedModal');
      }
    }
  }, [_c('recipe-declined-modal', {
    attrs: {
      "product-name": this.pdm && this.pdm.product_name
    }
  })], 1) : _vm._e(), !_vm.queryParams.slim ? _c('new-modal-wrapper', {
    attrs: {
      "widthModal": '90%',
      "maxWidthModal": 500,
      "show-close-icon": false,
      "click-to-close": false,
      "modal-name": "replacementModal",
      "title": "replacementModalTitle",
      "description": "replacementModalDescription",
      "cta-primary-button": "replacementModalCTA"
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.$refs.shareInStore.ctaAction();
      }
    }
  }, [_c('replacement-modal', {
    ref: "shareInStore"
  })], 1) : _vm._e(), !_vm.configuration.modals.shareInStore && !_vm.queryParams.slim ? _c('share-in-store-modal') : _vm._e(), _vm.enableSplashPage && !_vm.queryParams.slim ? _c('splash-page-modal') : _vm._e()] : _vm._e(), !_vm.queryParams.slim ? _c('graphics-controller', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isApparelEnabled,
      expression: "isApparelEnabled"
    }]
  }) : _vm._e(), _c('pick-your-own-color-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeGroup === 'yourcolors' && !_vm.$store.state.utils.isSplashModalOpen && !_vm.queryParams.slim,
      expression: "activeGroup === 'yourcolors' && !$store.state.utils.isSplashModalOpen && !queryParams.slim"
    }]
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }